import { apiFetch, buildQuery } from "./apiClient";
import type { AuditItem, AuditListData } from "../types/api";

export interface AuditListParams {
  action?: string;
  resourceType?: string;
  resourceId?: string;
  actorEmail?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

/** GET /api/v1/admin/audit - newest-first. */
export function listAudit(params: AuditListParams = {}): Promise<AuditListData> {
  return apiFetch<AuditListData>(`/api/v1/admin/audit${buildQuery(params)}`);
}

/** GET /api/v1/admin/audit/{auditId} - single row, includes `changes`. */
export function getAuditItem(id: number | string): Promise<AuditItem> {
  return apiFetch<AuditItem>(`/api/v1/admin/audit/${id}`);
}
